import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"caption-bold {{local-class (concat \"badge-status \" this.level) from=\"@qonto/ui-kit/components/badge/status.module.css\"}}\" ...attributes>\n  {{@text}}\n</span>", {
  moduleName: "@qonto/ui-kit/components/badge/status.hbs"
});